module.exports = __webpack_public_path__ + "static/media/tooltip_interest.89bfd968.svg";